// Project-notebook endpoint bindings (backend /admin/notebook/*).
// The editable "Overview" tab: a persisted checklist the admin AND Claude Code
// sessions add items to and mark done. All require an admin JWT (require_admin).
import { api } from "./client";

export type NotebookStatus = "todo" | "in_progress" | "done";

export interface NotebookItem {
  id: string;
  title: string;
  body: string | null;
  status: NotebookStatus;
  section: string | null;
  author: string; // "you" | "claude" | free-form session label
  sort_order: number;
  created_at: string;
  updated_at: string;
  done_at: string | null;
}

export interface NotebookItemCreate {
  title: string;
  body?: string | null;
  status?: NotebookStatus;
  section?: string | null;
  author?: string;
  sort_order?: number;
}

export interface NotebookItemUpdate {
  title?: string;
  body?: string | null;
  status?: NotebookStatus;
  section?: string | null;
  sort_order?: number;
}

export function listNotebook(): Promise<NotebookItem[]> {
  return api.get<NotebookItem[]>("/admin/notebook");
}

export function createNotebookItem(body: NotebookItemCreate): Promise<NotebookItem> {
  return api.post<NotebookItem>("/admin/notebook", body);
}

export function updateNotebookItem(
  id: string,
  patch: NotebookItemUpdate,
): Promise<NotebookItem> {
  return api.patch<NotebookItem>(`/admin/notebook/${encodeURIComponent(id)}`, patch);
}

export function deleteNotebookItem(id: string): Promise<void> {
  return api.delete<void>(`/admin/notebook/${encodeURIComponent(id)}`);
}
